import {
    AssessmentFormQuestionTypeEnum,
    EvaluationQuestionTypeEnum,
    SurveyQuestionTypeEnum,
} from "@genesys/cloud-frontend/models";

export const BaseQuestionType = Object.freeze({
    ...AssessmentFormQuestionTypeEnum,
    ...SurveyQuestionTypeEnum,
    ...EvaluationQuestionTypeEnum,
});
